import '@fokke-/bartender.js/dist/bartender.css'
import 'glightbox/dist/css/glightbox.css'
import '../css/styles.scss'
import Site from '../lib/Site.js'

if (document.body.id !== 'form-builder-form') {
	window._site = new Site()
}
